// extracted by mini-css-extract-plugin
export default {"PageTitle":"style_PageTitle__u1-V9"};